import { useEffect, useRef, type ReactNode } from 'react';
import { useT } from '../i18n';
import { useUi } from '../store/ui';

// ------------------------------------------------------------------ icons
const PATHS: Record<string, string> = {
  back: 'M15 18l-6-6 6-6',
  close: 'M18 6L6 18M6 6l12 12',
  home: 'M3 10.5L12 3l9 7.5V20a1 1 0 01-1 1h-5v-6H9v6H4a1 1 0 01-1-1z',
  play: 'M7 4l13 8-13 8z',
  users: 'M16 11a4 4 0 10-8 0 4 4 0 008 0zM3 21a9 9 0 0118 0',
  trophy: 'M8 21h8M12 17v4M7 4h10v5a5 5 0 01-10 0zM17 5h3v2a3 3 0 01-3 3M7 5H4v2a3 3 0 003 3',
  user: 'M12 12a5 5 0 100-10 5 5 0 000 10zM4 22a8 8 0 0116 0',
  bell: 'M18 8a6 6 0 00-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 01-3.4 0',
  settings: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z',
  chat: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',
  share: 'M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13',
  copy: 'M9 9h11v11H9zM5 15H4a1 1 0 01-1-1V4a1 1 0 011-1h10a1 1 0 011 1v1',
  plus: 'M12 5v14M5 12h14',
  gift: 'M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z',
  target: 'M12 22a10 10 0 100-20 10 10 0 000 20zM12 18a6 6 0 100-12 6 6 0 000 12zM12 14a2 2 0 100-4 2 2 0 000 4z',
  store: 'M3 9l1.5-5h15L21 9M3 9v11h18V9M3 9h18M9 20v-6h6v6',
  video: 'M23 7l-7 5 7 5zM1 5h15v14H1z',
  lock: 'M5 11h14v10H5zM8 11V7a4 4 0 018 0v4',
  unlock: 'M5 11h14v10H5zM8 11V7a4 4 0 017.5-2',
  search: 'M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.3-4.3',
  check: 'M20 6L9 17l-5-5',
  logout: 'M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9',
  flag: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7',
  info: 'M12 22a10 10 0 100-20 10 10 0 000 20zM12 16v-4M12 8h.01',
  key: 'M21 2l-2 2m-7.6 7.6a5.5 5.5 0 11-7.8 7.8 5.5 5.5 0 017.8-7.8zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4',
  calendar: 'M3 5h18v16H3zM16 3v4M8 3v4M3 10h18',
  bolt: 'M13 2L3 14h9l-1 8 10-12h-9z',
  star: 'M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z',
  smile: 'M12 22a10 10 0 100-20 10 10 0 000 20zM8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01',
  shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  qr: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h3v3h-3zM18 18h3v3h-3zM14 18h2M18 14h3',
};

export function Icon({ name, size = 22, label, className }: { name: keyof typeof PATHS | string; size?: number; label?: string; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden={!label} aria-label={label} role={label ? 'img' : undefined} className={className}>
      <path d={PATHS[name] ?? PATHS.info} />
    </svg>
  );
}

export function CoinIcon({ size = 20 }: { size?: number }) {
  return (
    <svg className="coin-icon" width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <defs>
        <radialGradient id="cg" cx="35%" cy="30%" r="75%">
          <stop offset="0" stopColor="#fff3c4" />
          <stop offset="0.45" stopColor="#f6c453" />
          <stop offset="1" stopColor="#b7791f" />
        </radialGradient>
      </defs>
      <circle cx="12" cy="12" r="11" fill="url(#cg)" stroke="#8a5a12" strokeWidth="1" />
      <circle cx="12" cy="12" r="7.5" fill="none" stroke="#8a5a12" strokeWidth="1" opacity="0.6" />
      <text x="12" y="16" textAnchor="middle" fontSize="10" fontWeight="900" fill="#7a4d0b">T</text>
    </svg>
  );
}

export function Coins({ amount, size = 20, signed = false, className = '' }: { amount: number; size?: number; signed?: boolean; className?: string }) {
  const txt = new Intl.NumberFormat().format(Math.abs(amount));
  return (
    <span className={`coin ${className}`}>
      <CoinIcon size={size} />
      <span className="num">
        {signed ? (amount > 0 ? '+' : amount < 0 ? '−' : '') : amount < 0 ? '−' : ''}
        {txt}
      </span>
    </span>
  );
}

// ------------------------------------------------------------------ avatar
const EMOJI = ['🦁', '🐯', '🐼', '🦊', '🐨', '🐸', '🐵', '🦄', '🐙', '🐧', '🦉', '🐺', '🐻', '🐰', '🐲', '🦅', '🐬', '🦋', '🐝', '🦖', '🐱', '🐶', '🐮', '🐹'];
export function avatarStyle(avatar: string | undefined): { emoji: string; background: string } {
  const n = Math.max(1, Number((avatar ?? 'avatar_01').split('_')[1] ?? 1)) - 1;
  const hue = (n * 47) % 360;
  return { emoji: EMOJI[n % EMOJI.length]!, background: `linear-gradient(135deg, hsl(${hue} 70% 55%), hsl(${(hue + 40) % 360} 70% 38%))` };
}

export function Avatar({ avatar, size = 44, status, name }: { avatar?: string; size?: number; status?: 'online' | 'in_game' | 'offline' | 'idle'; name?: string }) {
  const s = avatarStyle(avatar);
  return (
    <span className="avatar" style={{ ['--size' as string]: `${size}px`, background: s.background }} role="img" aria-label={name ? `${name}'s avatar` : 'avatar'}>
      <span style={{ fontSize: size * 0.52 }}>{s.emoji}</span>
      {status && <span className={`status ${status === 'idle' ? 'online' : status}`} />}
    </span>
  );
}

// ------------------------------------------------------------------ overlays
export function Modal({ open, onClose, title, children, dismissable = true }: { open: boolean; onClose: () => void; title?: string; children: ReactNode; dismissable?: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const prev = document.activeElement as HTMLElement | null;
    ref.current?.focus();
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && dismissable && onClose();
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      prev?.focus?.();
    };
  }, [open, onClose, dismissable]);
  if (!open) return null;
  return (
    <div className="overlay" onClick={() => dismissable && onClose()}>
      <div className="modal" role="dialog" aria-modal="true" aria-label={title} tabIndex={-1} ref={ref} onClick={(e) => e.stopPropagation()}>
        {title && <h2>{title}</h2>}
        {children}
      </div>
    </div>
  );
}

export function Sheet({ open, onClose, title, children }: { open: boolean; onClose: () => void; title?: string; children: ReactNode }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="overlay sheet-overlay" onClick={onClose}>
      <div className="sheet" role="dialog" aria-modal="true" aria-label={title} onClick={(e) => e.stopPropagation()}>
        <div className="grabber" />
        {title && (
          <div className="spread" style={{ marginBottom: 12 }}>
            <h2 style={{ margin: 0, fontSize: 'var(--fs-xl)' }}>{title}</h2>
            <button className="icon-btn" onClick={onClose} aria-label="Close">
              <Icon name="close" />
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

export function Confirm({ open, title, body, confirmText, danger, onConfirm, onCancel }: { open: boolean; title: string; body?: string; confirmText: string; danger?: boolean; onConfirm: () => void; onCancel: () => void }) {
  const t = useT();
  return (
    <Modal open={open} onClose={onCancel} title={title}>
      {body && <p className="dim">{body}</p>}
      <div className="row" style={{ marginTop: 16 }}>
        <button className="btn ghost grow" onClick={onCancel}>
          {t('common.cancel')}
        </button>
        <button className={`btn grow ${danger ? 'danger' : 'primary'}`} onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </Modal>
  );
}

export function Toasts() {
  const toasts = useUi((s) => s.toasts);
  const dismiss = useUi((s) => s.dismiss);
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.kind}`} onClick={() => dismiss(t.id)}>
          <span className="dot" />
          <span>{t.text}</span>
        </div>
      ))}
    </div>
  );
}

// ------------------------------------------------------------------ states
export function Loading({ label }: { label?: string }) {
  const t = useT();
  return (
    <div className="state" aria-busy="true">
      <div className="spinner" />
      <span>{label ?? t('common.loading')}</span>
    </div>
  );
}

export function Empty({ emoji = '🃏', title, body, action }: { emoji?: string; title: string; body?: string; action?: ReactNode }) {
  return (
    <div className="state">
      <div className="emoji" aria-hidden>
        {emoji}
      </div>
      <h3>{title}</h3>
      {body && <p style={{ margin: 0 }}>{body}</p>}
      {action}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message?: string; onRetry?: () => void }) {
  const t = useT();
  return (
    <div className="state" role="alert">
      <div className="emoji" aria-hidden>
        😕
      </div>
      <h3>{message ?? t('error.generic')}</h3>
      {onRetry && (
        <button className="btn" onClick={onRetry}>
          {t('common.retry')}
        </button>
      )}
    </div>
  );
}

export function Skeleton({ h = 60, w = '100%', r }: { h?: number; w?: number | string; r?: number }) {
  return <div className="skeleton" style={{ height: h, width: w, borderRadius: r }} />;
}

export function Toggle({ checked, onChange, label }: { checked: boolean; onChange: (v: boolean) => void; label: string }) {
  return <button className="toggle" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} />;
}

export function Segmented<T extends string>({ value, options, onChange, label }: { value: T; options: { value: T; label: string }[]; onChange: (v: T) => void; label: string }) {
  return (
    <div className="segmented" role="group" aria-label={label}>
      {options.map((o) => (
        <button key={o.value} aria-pressed={o.value === value} onClick={() => onChange(o.value)}>
          {o.label}
        </button>
      ))}
    </div>
  );
}

export function Progress({ value, max, label }: { value: number; max: number; label?: string }) {
  const pct = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  return (
    <div className="progress" role="progressbar" aria-valuemin={0} aria-valuemax={max} aria-valuenow={value} aria-label={label}>
      <span style={{ width: `${pct}%` }} />
    </div>
  );
}

export function TopBar({ title, onBack, right }: { title: string; onBack?: () => void; right?: ReactNode }) {
  const t = useT();
  return (
    <div className="topbar">
      {onBack && (
        <button className="icon-btn" onClick={onBack} aria-label={t('common.back')}>
          <Icon name="back" />
        </button>
      )}
      <h1 className="page-title grow" style={{ margin: 0 }}>
        {title}
      </h1>
      {right}
    </div>
  );
}

/** Animated count-up for coin/XP rewards. */
export function CountUp({ to, duration = 900 }: { to: number; duration?: number }) {
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const start = performance.now();
    let raf = 0;
    const fmt = new Intl.NumberFormat();
    const step = (now: number) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - (1 - p) ** 3;
      el.textContent = fmt.format(Math.round(to * eased));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [to, duration]);
  return <span ref={ref} className="num" />;
}

export function Confetti({ pieces = 80 }: { pieces?: number }) {
  const colors = ['#22d3a6', '#f6c453', '#ff5c7a', '#7c5cff', '#4cc3ff', '#ffffff'];
  return (
    <div className="confetti" aria-hidden>
      {Array.from({ length: pieces }, (_, i) => (
        <i
          key={i}
          style={{
            left: `${Math.random() * 100}%`,
            background: colors[i % colors.length],
            animationDuration: `${1.8 + Math.random() * 1.8}s`,
            animationDelay: `${Math.random() * 0.4}s`,
            transform: `rotate(${Math.random() * 360}deg)`,
          }}
        />
      ))}
    </div>
  );
}
